export function changeActiveDropdown(key: string) {
  return {
    type: 'CHANGE_ACTIVE_DROPDOWN',
    payload: {
      key,
    }
  }
}
